/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:31017ed5-e9b9-464d-8afa-5921c0a08e63",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_SE7wgNKJu",
    "aws_user_pools_web_client_id": "73n4o1412cckkv63v1stfrdfqq",
    "oauth": {
        "domain": "pixmdauthdomain-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/soc/,https://www.pixmd.com/soc/",
        "redirectSignOut": "http://localhost:3000/soc/,https://www.pixmd.com/soc/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "AMAZON"
    ],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "6",
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL, PHONE_NUMBER"
    ],
    "aws_appsync_graphqlEndpoint": "https://fyneb44vkbbbbk7yfp4ocoty6q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "lambdaapi",
            "endpoint": "https://pnbmq3nth1.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "pixmds3bucket140845-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
